import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Grid, Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import { decodeData } from "../../components/Comman/Util/Base64";
import { blackColor } from "../../config/ColorObj";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { showNotification } from "../Landing/Landing.slice";

const reportingDomainUrl = localStorage.getItem("linkToRedirectToReportingModule") || "https://dmsreporting.byteelephants.com";

const VideoLinkRedirect = ({ showNotification }) => {
  const getLoginPersonSessionToken = () => {
    const stored = localStorage.getItem("token");
    if (!stored) return "";

    try {
      const decoded = decodeData(stored);
      return decoded && decoded.trim() ? decoded.trim() : stored.trim();
    } catch (e) {
      return stored.trim();
    }
  };

  const onRedirect = () => {
    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    const sessionToken = getLoginPersonSessionToken();
    if (!sessionToken) {
      showNotification({ msg: serverMsg, severity: "error" });
      return;
    }

    let base = reportingDomainUrl.trim();
    while (base.endsWith("/")) {
      base = base.slice(0, -1);
    }
    if (!/^https?:\/\//i.test(base)) {
      base = `https://${base}`;
    }

    const tokenValue = sessionToken.replace(/^Bearer\s+/i, "").trim();
    const finalUrl = `${base}?token=${tokenValue}`;

    const anchor = document.createElement("a");
    anchor.setAttribute("href", finalUrl);
    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener noreferrer");
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: 2,
      }}
      elevation={0}
    >
      <LandingScreenHeader
        screenTitle={"Redirect URL"}
        showTable={false}
        showBackButton={false}
        showAddButton={false}
      />

      <div>
        <br />
        <Grid
          container
          spacing={2}
          alignItems="center"
          sx={{ flexWrap: { xs: "wrap", sm: "nowrap" } }}
        >
          <Grid item xs={12} sm="auto">
            <TypographyCompo variant="body1" fontSize={16} color={blackColor}>
              Click here to redirect
            </TypographyCompo>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <ArrowForwardIcon
                sx={{
                  fontSize: 22,
                  color: blackColor,
                }}
              />
              <ButtonCompo
                size="medium"
                onClick={onRedirect}
                variant="contained"
                name="Redirect"
              />
            </Box>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = { showNotification };
export default connect(mapStateToProps, mapDispatchToProps)(VideoLinkRedirect);
